import React from "react";
import View from "./View";
import {
  Button,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import FileCard from "components/files/FileCard";
import { useDispatch, useSelector } from "react-redux";
import { fonts } from "fonts";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { modalsActions } from "store/react-lib/generic-ui/modals";
import UploadFileModal from "components/files/UploadFileModal";
import Loader from "components/react-lib/generic-ui/Loader";
import { useTheme } from "@emotion/react";

export default function FilesView() {

  const theme = useTheme();
  const dispatch = useDispatch();
  const filesState = useSelector((state) => state.collections.files);

  const renderFiles = () => {
    const loading = !filesState || filesState.loading;
    if (loading) {
      return <Loader message="Loading files" />;
    }
    if (!loading && filesState.documents.length === 0) {
      return (
        <Typography
          fontFamily={fonts.geist}
          textAlign="center"
          sx={{
            color: theme.palette.text.main,
          }}
        >
          No files yet.
        </Typography>
      );
    }
    return [...filesState.documents].sort((x, y) => -(x.createdAt - y.createdAt)).map((file) => (
      <FileCard key={file.id} file={file} />
    ));
  };

  return (
    <View
      renderLeftActions={() => (
        <Typography
          fontFamily={fonts.anton}
          sx={{
            color: theme.palette.text.main,
          }}
        >
          File Manager
        </Typography>
      )}
    >
      <UploadFileModal />
      <Container maxWidth="md">
        <Button
          fullWidth
          variant="contained"
          color="primary"
          startIcon={<FileUploadIcon />}
          onClick={() => dispatch(modalsActions.openModal("uploadFileModal"))}
        >
          Upload File
        </Button>
        <Stack py={2}
          sx={{
            overflowY: "auto",
            height: "90%",
          }}
        >
          <Stack py={2} spacing={2}>
            {renderFiles()}
          </Stack>
        </Stack>
      </Container>
    </View>
  );
}
